// extracted by mini-css-extract-plugin
module.exports = {"tag":"JobSeekerCard_tag__SEnAZ","image":"JobSeekerCard_image__1xltA","text":"JobSeekerCard_text__1tcQG","sending":"JobSeekerCard_sending__3lDBV"};